var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 5C16.225 5 5 16.225 5 30C5 43.775 16.225 55 30 55C43.775 55 55 43.775 55 30C55 16.225 43.775 5 30 5ZM38.4 35.75C39.125 36.475 39.125 37.675 38.4 38.4C38.025 38.775 37.55 38.95 37.075 38.95C36.6 38.95 36.125 38.775 35.75 38.4L30 32.65L24.25 38.4C23.875 38.775 23.4 38.95 22.925 38.95C22.45 38.95 21.975 38.775 21.6 38.4C20.875 37.675 20.875 36.475 21.6 35.75L27.35 30L21.6 24.25C20.875 23.525 20.875 22.325 21.6 21.6C22.325 20.875 23.525 20.875 24.25 21.6L30 27.35L35.75 21.6C36.475 20.875 37.675 20.875 38.4 21.6C39.125 22.325 39.125 23.525 38.4 24.25L32.65 30L38.4 35.75Z",
    fill: "#EC3B3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose1);
export default __webpack_public_path__ + "static/media/close-1.ced7b221cb53ac7ab01908390f98daf3.svg";
export { ForwardRef as ReactComponent };